/**
 * CHHA Missed Visit — options + empty payload.
 * After shared common header (1–6): Reason → Attempts → POC Analysis →
 * Coordination → Follow-up.
 */

import { emptyChhaCommonHeader } from "./chhaNotesCommonHeaderUtils";

export const MISSED_REASON_OPTIONS = [
  "Patient Refused",
  "Patient Hospitalized",
  "Patient Not Home",
  "Agency/Staffing Conflict",
  "Weather/Environment",
];

export const ATTEMPT_METHOD_OPTIONS = [
  "Phone Call",
  "SMS/Text",
  "Voicemail Left",
  "In Person",
  "Other",
];

export const INTERVENTION_AFFECTED_OPTIONS = [
  "Personal Care/Hygiene (ADLs)",
  "Safe Transfers/Ambulation support",
  "Meal Prep/Nutritional Intake monitoring",
  "Home Exercise Program (HEP) assistance",
];

export const COORDINATION_DISCIPLINE_OPTIONS = ["RN", "PT", "OT", "SLP"];

export const toggleInList = (list, item) => {
  const arr = Array.isArray(list) ? list : [];
  return arr.includes(item) ? arr.filter((x) => x !== item) : [...arr, item];
};

export const today = () => new Date().toISOString().slice(0, 10);

export const emptyAttemptRow = (id) => ({
  id: id || `attempt-${Date.now()}`,
  time: "",
  method: "",
  outcome: "",
});

export const defaultAttemptRows = () => [
  emptyAttemptRow("attempt-1"),
  emptyAttemptRow("attempt-2"),
];

/** Full editable CHHA Missed Visit payload (JSON on dedicated row). */
export const emptyChhaMissedVisitPayload = () => ({
  billingCode: "",
  timeIn: "",
  timeOut: "",
  missedVisitDate: "",
  commonHeader: emptyChhaCommonHeader(),

  // —— 7. Reason for Missed Visit ——
  missedReason: "",
  reasonDetails: "",

  // —— 8. Attempts Made ——
  attemptRows: defaultAttemptRows(),

  // —— 9. Plan of Care Analysis ——
  interventionsAffected: [],
  interventionsOther: "",
  functionalImpact: "",

  // —— 10. Coordination & Notifications ——
  caseManagerNotified: false,
  caseManagerNotifiedDate: "",
  caseManagerNotifiedTime: "",
  physicianNotified: false,
  physicianNotifiedDate: "",
  physicianNotifiedTime: "",
  familyNotified: false,
  familyNotifiedDate: "",
  familyNotifiedTime: "",

  // —— 11. Follow-Up Plan ——
  rescheduledDate: "",
  nextScheduledFrequency: "",
  coordinationDisciplines: [],
  clinicalStrategy: "",
});

export const CHHA_MISSED_ARRAY_KEYS = [
  "interventionsAffected",
  "coordinationDisciplines",
];

export const normalizeAttemptRows = (rows) => {
  if (!Array.isArray(rows) || rows.length === 0) return defaultAttemptRows();
  return rows.map((row, index) => ({
    id: String(row?.id || `attempt-${index + 1}`),
    time: String(row?.time || ""),
    method: String(row?.method || ""),
    outcome: String(row?.outcome || ""),
  }));
};
